import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Row, Col, Button, Modal, Collapse, Form, Image, InputGroup } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoTabProvider } from "react-auto-tab";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { base64ToBlob, generateRandomString, mapMstToOptions } from "utils/HelperFunction";
import { getBusinessStatus } from "../redux/handlers/logic/getBusinessStatus.handler";
var businessID = null;
export function Dashboard() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(0), 2), businessStatus = _useState[0], setBusinessStatus = _useState[1];
    var accessToken = localStorage.getItem("accessToken");
    var memID = null;
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member, _payload_member1;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    memID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.mb_mem_id) || null;
                    businessID = parseInt((_payload_member1 = payload.member) === null || _payload_member1 === void 0 ? void 0 : _payload_member1.bus_business_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var getBusinessStatusReducer = useAppSelector(function(state) {
        return state.getBusinessStatusReducer;
    });
    useEffect(function() {
        setIsLoading(getBusinessStatusReducer.isFetching);
        if (getBusinessStatusReducer.data) {
            if (getBusinessStatusReducer.data.data.bus_business_status) {
                setBusinessStatus(getBusinessStatusReducer.data.data.bus_business_status || "");
            }
        }
    }, [
        getBusinessStatusReducer
    ]);
    useEffect(function() {
        if (businessID != null && businessID != 0 && businessID != undefined) {
            dispatch(getBusinessStatus(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "document-page",
        children: businessStatus == 1 || businessStatus == 0 ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Row, {
                className: "align-items-center justify-content-center mb-3",
                children: /*#__PURE__*/ _jsxs(Col, {
                    xs: 12,
                    md: 12,
                    lg: 6,
                    xl: 6,
                    className: "text-center justify-content-center ",
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/profilebanner.png",
                            className: "mx-auto",
                            style: {
                                height: "100%",
                                maxHeight: "450px",
                                width: "auto"
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-20 fw-500 tc-3",
                            children: "กรุณาลงทะเบียนคู่ค้าก่อนเข้าใช้งาน"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                navigate("/info/create");
                            },
                            className: "btn-danger mt-3",
                            children: "เริ่มต้นลงทะเบียน"
                        })
                    ]
                })
            })
        }) : businessStatus == 2 ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Row, {
                className: "align-items-center justify-content-center mb-3",
                children: /*#__PURE__*/ _jsxs(Col, {
                    xs: 12,
                    md: 12,
                    lg: 6,
                    xl: 6,
                    className: "text-center justify-content-center ",
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/profilebanner.png",
                            className: "mx-auto",
                            style: {
                                height: "100%",
                                maxHeight: "450px",
                                width: "auto"
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-20 fw-500 tc-3",
                            children: "กำลังตรวจสอบสถานะการลงทะเบียนคู่ค้า"
                        })
                    ]
                })
            })
        }) : businessStatus == 3 ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Row, {
                className: "align-items-center justify-content-center mb-3",
                children: /*#__PURE__*/ _jsxs(Col, {
                    xs: 12,
                    md: 12,
                    lg: 6,
                    xl: 6,
                    className: "text-center justify-content-center ",
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/profilebanner.png",
                            className: "mx-auto",
                            style: {
                                height: "100%",
                                maxHeight: "450px",
                                width: "auto"
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-20 fw-500 tc-3",
                            children: "คุณลงทะเบียนคู่ค้าสำเร็จ"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-20 fw-500 tc-3",
                            children: "ขั้นตอนต่อไป นำเสนอสินค้าของท่าน"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                navigate("/product");
                            },
                            className: "btn-danger mt-3",
                            children: "นำเสนอสินค้า"
                        })
                    ]
                })
            })
        }) : businessStatus == 4 ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Row, {
                className: "align-items-center justify-content-center mb-3",
                children: /*#__PURE__*/ _jsxs(Col, {
                    xs: 12,
                    md: 12,
                    lg: 6,
                    xl: 6,
                    className: "text-center justify-content-center ",
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/profilebanner.png",
                            className: "mx-auto",
                            style: {
                                height: "100%",
                                maxHeight: "450px",
                                width: "auto"
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center fs-20 fw-500 tc-3",
                            children: "กรุณาแก้ไขข้อมูลลงทะเบียนคู่ค้า"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                navigate("/info/create");
                            },
                            className: "btn-danger mt-3",
                            children: "แก้ไขข้อมูล"
                        })
                    ]
                })
            })
        }) : null
    });
}
